<template>
  <b-container fluid class="booking-sum-up public-show">
      <div v-if="isLoaded" class="header">
        <page-title>
          <b-row>
            <b-col cols="6" md="7">{{ $t('booking.my_booking') }}</b-col>
          </b-row>
        </page-title>
      </div>

      <booking-show v-if="isLoaded" v-bind="$data" :is-manager="isManager"
                    @update="initBooking($event)" :is-unlogged="isUnlogged"
      />

    <div v-if="errors.length !== 0" class="errors">
      <div v-for="error in errors" v-bind:key="error" class="text-center">
        <h2> {{ $t(`error.${error}`) }}</h2>
      </div>
    </div>
  </b-container>
</template>

<script>
import backButton from '@/components/frontoffice/button/back'
import frontofficeFrame from '@/components/frontoffice/frame'
import frontofficeLoader from '@/components/frontoffice/loader'
import BookingShow from '@/components/frontoffice/Booking/show'
import CommonApi from '@/api/commonApi'
import pageTitle from '@/components/backoffice/pageTitle'

export default {
  components: {
    frontofficeFrame,
    frontofficeLoader,
    BookingShow,
    pageTitle,
    backButton
  },

  props: {
    isUnlogged: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      commonApi: new CommonApi(),
      booking: null,
      isLoaded: false,
      isManager: false,
      actions: [],
      errors: [],
      stateFormation: false,
      anonymous: true
    }
  },

  created () {
    this.initBooking()
    this.initCancellationReasons()
  },

  methods: {
    initBooking (token = null) {
      this.commonApi.searchBookingPublic(this.$route.params.token)
        .then(response => {
          if (response.data.success) {
            this.booking = response.data.data.booking
            this.actions = response.data.data.actions
            delete this.actions.show
            this.isLoaded = true
          } else {
            Object.entries(response.data.errors).forEach(error => {
              this.errors.push(this.$te(`error.${error[0]}`)
                ? error[0]
                : error[1]
              )
            })
          }
        })
    },

    initCancellationReasons () {
      this.commonApi.bookingCancellationReasonsPublic(this.$route.params.token).then((response) => {
        this.$store.commit(
          'data/bookingCancellationReasons',
          response.data.data
        )
      })
    }
  }
}
</script>

<style scoped>
.public-show{
  padding-left: 8%;
  padding-right: 8%;
  padding-top: 2%;
}
</style>
